import React from "react";

const UserIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.363"
      height="20.001"
      viewBox="0 0 20.363 20.001"
    >
      <g
        id="Group_1270"
        data-name="Group 1270"
        transform="translate(-1164.518 -184.353)"
      >
        <path
          id="Path_1301"
          data-name="Path 1301"
          d="M278.443,383.85H258.08a9.751,9.751,0,0,1,9.74-9.74h.882a9.751,9.751,0,0,1,9.74,9.74Z"
          transform="translate(906.438 -179.495)"
          fill={fill}
        />
        <path
          id="Path_1302"
          data-name="Path 1302"
          d="M330.37,257.763a4.89,4.89,0,1,1-4.89-4.89,4.89,4.89,0,0,1,4.89,4.89"
          transform="translate(849.218 -68.52)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export default UserIcon;
